import React, { useState, useRef, useEffect } from "react";
import { Button } from "antd";

interface ExpandableTextProps {
  text: string;
  collapsedHeight?: number; // default to 250px
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  collapsedHeight = 250,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setShowButton(textRef.current.scrollHeight > collapsedHeight);
    }
  }, [text, collapsedHeight]);

  return (
    <div
      style={{ position: "relative", display: "flex", flexDirection: "column" }}
    >
      <div
        ref={textRef}
        style={{
          maxHeight: expanded ? "none" : collapsedHeight,
          overflow: expanded ? "visible" : "hidden",
          transition: "max-height 0.3s",
        }}
        className="body-16-regular"
      >
        {text}
      </div>
      {showButton && (
        <Button
          type="link"
          onClick={() => setExpanded((e) => !e)}
          style={{ padding: 0, alignSelf: "flex-end", height: 30 }}
        >
          {expanded ? "Show less" : "Show more"}
        </Button>
      )}
    </div>
  );
};

export default ExpandableText;
